import optionModel from '../format/convert-fields/option'
import optionTypes from '../format/convert-fields/option-types'
import { arraySwap, copyJson, dateNumber } from '@/views/question-editor/utils/function'

const options = {
  number: 1,
  id () {
    return 'OPT' + dateNumber() + options.number++
  },
  make (type) {
    let data = {}
    optionTypes[type].forEach((field) => {
      data[field] = optionModel[field]
    })
    data.id = this.id('option')
    return copyJson(data)
  },
  insert (options, option, index) {
    // 默认 index
    !Number.isInteger(index) && (index = options.length)
    options.splice(index, 0, option)
    return option
  },
  create (options, type, index) {
    return this.insert(options, this.make(type), index)
  },
  up (options, index) {
    if (index) {
      // 交换位置
      return arraySwap(options, index, index - 1)
    }
    return false
  },
  down (options, index) {
    if (index < options.length - 1) {
      // 交换位置
      return arraySwap(options, index, index + 1)
    }
    return false
  },
  remove (options, index) {
    options.splice(index, 1)
  },
  copy (options, fromIndex, toIndex) {
    let newOption = copyJson(options[fromIndex])
    newOption.id = this.id()
    options.splice(toIndex, 0, newOption)
    return newOption
  },
  /**
   * 移除依赖这个选项的相关内容
   * @param options
   * @param optionId
   */
  removeDependency (options, optionId) {
    options.forEach((option) => {
      if (option.mutexOptions) {
        let index = option.mutexOptions.indexOf(optionId)
        if (index !== -1) {
          option.mutexOptions.splice(index, 1)
        }
      }
    })
  },
  addDependency (options, option) {
    if (option.mutexOptions) {
      options.forEach((_option) => {
        if (option.mutexOptions.includes(_option.id)) {
          _option.mutexOptions.push(option.id)
        }
      })
    }
  },
}

export default options



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/options.js